var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDIconHighContrast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21023 13H6.6321V5.72727H9.23153C9.96307 5.72727 10.5928 5.87287 11.1207 6.16406C11.6487 6.45289 12.0547 6.86837 12.3388 7.41051C12.6252 7.95265 12.7685 8.60133 12.7685 9.35653C12.7685 10.1141 12.6252 10.7652 12.3388 11.3097C12.0547 11.8542 11.6463 12.272 11.1136 12.5632C10.5833 12.8544 9.94886 13 9.21023 13ZM8.16974 11.6825H9.14631C9.60085 11.6825 9.98319 11.602 10.2933 11.4411C10.6058 11.2777 10.8402 11.0256 10.9964 10.6847C11.1551 10.3414 11.2344 9.89867 11.2344 9.35653C11.2344 8.81913 11.1551 8.37997 10.9964 8.03906C10.8402 7.69815 10.607 7.44721 10.2969 7.28622C9.98674 7.12524 9.6044 7.04474 9.14986 7.04474H8.16974V11.6825Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDIconHighContrast);
export default __webpack_public_path__ + "static/media/d-icon-high-contrast.47fe8300e653237270117a23a92281f1.svg";
export { ForwardRef as ReactComponent };